'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
	processInclude(require('./product/details'));
    // Spark changes for carousel and wishlist - BEGIN
    // processInclude(require('./product/spark/carousel/carouselThumbnails'));
    processInclude(require('./product/wishlist'));
    // Spark changes for carousel and wishlist - END
    processInclude(require('./product/lazyLoadCarouselImages'));
});
